import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '@lib/useTypedTranslation';
import { Card } from '@components/card/card';
import { TabPanel } from '@components/tabs/tab-panel';
import { LinkTab } from '@components/tabs/link-tab';

import { useWorldRoutes } from '../../../routes/parts/allWorldRoutes';
import { CoreOverview } from '../overview/coreOverview';
import { CoreDevices } from '../devices';
import { LocationTab } from './location/location';
import { ClusterContext, useClusterContext } from '../maps/clusterContext';

import './coreDevicesHub.css';

export const CoreDevicesHub = () => {
  const { t } = useTranslation();
  const { t: t2 } = useTranslation('maps');
  const { pathname } = useLocation();
  const routes = useWorldRoutes();
  const [state, dispatch] = useClusterContext();

  const defaultTabIndex = React.useMemo(() => {
    if (pathname === routes.core.devicesMap) {
      return 2;
    }
    if (pathname === routes.core.devicesList) {
      return 1;
    }
    return 0;
  }, [pathname, routes.core.devicesMap, routes.core.devicesList]);

  return (
    <Card className="core-devices-hub" noPadding>
      <ClusterContext.Provider value={{ state, dispatch }}>
        <TabPanel defaultTabIndex={defaultTabIndex} enableStatePreservation tabAlignment="start">
          <LinkTab id="overview" title={t('OVERVIEW')} link={routes.core.devices}>
            <CoreOverview />
          </LinkTab>
          <LinkTab id="list" title={t('LIST')} link={routes.core.devicesList}>
            <CoreDevices />
          </LinkTab>
          {/* passSelectedToChild so the location tab can remount its map when it becomes
              visible again - state preservation keeps it mounted but hidden otherwise */}
          <LinkTab id="location" title={t2('LOCATION_TAB')} link={routes.core.devicesMap} passSelectedToChild>
            <LocationTab />
          </LinkTab>
        </TabPanel>
      </ClusterContext.Provider>
    </Card>
  );
};
